import { useEffect } from "react";
import { GridStack } from "gridstack";
import GridItem from "../../../../Components/UiComponents/GridItem/GridItem";
import DMSHeader from "../../DMSHeader/DMSHeader";
import CreateResourceRegForm from "./CreateResourceRegForm";
import { useTranslation } from 'react-i18next';
import { useLocation } from "react-router-dom";

/* CreateResource component - Handles the creation and editing of resources. */
const CreateResource = () => {
    // Hook for internationalization
    const { t } = useTranslation();

    // Get location state to determine if in edit mode
    const { state } = useLocation();
    let edit = state?.edit;

    // Initialize GridStack layout system on component mount
    useEffect(() => {
        GridStack.init();
    }, []);

    //  Layout configuration for the grid items. Defines position, size and content for each grid element. 
    const layoutData = [
        {
            x: 0,           // Grid x-position
            y: 0,           // Grid y-position
            width: 12,      // Takes full width (assuming 12-column grid)
            height: 1,     // Height in grid units
            id: 0,          // Unique identifier
            component: (    // Rendered component
                <DMSHeader
                    title={edit ? t('Edit Resource Details') : t('resource_management_formheader')}
                    showIconsForback={true}
                />
            ),
            haveOverflowVisible: true,
        },
        {
            x: 0,
            y: 1,           // Positioned below the header
            width: 12,
            height: 14,     // Larger height for the form
            id: 1,
            component: <CreateResourceRegForm />,  // Resource form component
        },
    ];

    return (
        // GridStack container - will be initialized by the GridStack library
        <div className="grid-stack grid-stack-instance-1 smartpole__header--transition">
            {/* GridItem component that takes the layout configuration */}
            <GridItem layoutData={layoutData} />
        </div>
    );
};

export default CreateResource;